import * as THREE from 'three';

export const createGambitScene = (scene) => {
  const effect = new THREE.Group();
  scene.add(effect);

  const ringMaterial = new THREE.MeshBasicMaterial({
    color: 0xffbc76,
    transparent: true,
    opacity: 0.9,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    toneMapped: false,
  });
  const ring = new THREE.Mesh(
    new THREE.TorusGeometry(0.62, 0.035, 8, 48),
    ringMaterial
  );
  ring.rotation.x = Math.PI / 2;
  effect.add(ring);

  const shardMaterial = new THREE.MeshBasicMaterial({
    color: 0xff8b73,
    transparent: true,
    opacity: 0.95,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    toneMapped: false,
  });
  const shards = new THREE.InstancedMesh(
    new THREE.TetrahedronGeometry(0.13, 0),
    shardMaterial,
    16
  );
  effect.add(shards);
  const fragment = new THREE.Object3D();

  return {
    update({ stage, elapsed = 0, progress = 0, diePosition }) {
      const visible = ['charging', 'blast', 'flight'].includes(stage);
      effect.visible = visible;
      if (!visible) return;
      effect.position.copy(diePosition);

      if (stage === 'charging') {
        ring.visible = true;
        shards.visible = false;
        ring.scale.setScalar(0.8 + progress * 0.25);
        ring.rotation.z += 0.08;
        ringMaterial.opacity = 0.55 + Math.sin(elapsed * 26) * 0.2;
        return;
      }

      const burstProgress = stage === 'blast' ? progress : 1;
      ring.visible = stage === 'blast' && burstProgress < 1;
      ring.scale.setScalar(0.8 + burstProgress * 4.2);
      ringMaterial.opacity = Math.max(0, 0.9 * (1 - burstProgress));
      shards.visible = stage === 'blast';
      for (let index = 0; index < shards.count; index += 1) {
        const angle = index * 2.39996;
        const vertical = ((index % 5) - 2) * 0.32;
        fragment.position.set(
          Math.cos(angle) * burstProgress * 2.5,
          vertical * burstProgress + burstProgress * 1.1,
          Math.sin(angle) * burstProgress * 2.5
        );
        fragment.rotation.set(
          angle + burstProgress * 7,
          index + burstProgress * 5,
          angle * 0.7
        );
        fragment.scale.setScalar(Math.max(0.01, 1 - burstProgress * 0.65));
        fragment.updateMatrix();
        shards.setMatrixAt(index, fragment.matrix);
      }
      shardMaterial.opacity = Math.max(0, 0.95 * (1 - burstProgress));
      shards.instanceMatrix.needsUpdate = true;
    },
  };
};
